import styled, { css } from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: #CDD3E1;
    width: 130px;
    height: 46px;
    border-radius: 30px;
    text-align: center;
`;

const Count = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 30px;
    background-color: white;
    box-shadow: 0px 4px 4px 0px #00000040;
    font-size: 16px;
    font-weight: 700;
    color: ${theme.textDark};
`;

const NumericOperator = styled.span<{
    $disabled?: boolean;
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 24px;
    font-weight: 700;
    color: ${theme.textDark};
    text-align: center;
    cursor: pointer;

    ${props => props.$disabled && css`
        color: ${theme.textLight};
        cursor: default;
    `}
`;



export { Container, Count, NumericOperator };